module.exports = __webpack_public_path__ + "01_glasses_black.91f58e1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/01_glasses_black.png
// module id = WlVa
// module chunks = 0